import { MutualFundListItem } from '../power-rebalancing/MutualFundList'
import { PowerPerformanceForms } from '../../types/mutual-fund-detail.types'
import { useBottomSheet } from '../../state-management/contexts/BottomSheetContext'
import RegularToDirectBottomSheet from './RegularToDirectBottomSheet'
import { RegularToDirectSummaryResponse } from '../../types/regular-to-direct-plan.types'
import MutualFundListItemSkeleton from '../skeletons/MutualFundListItemSkeleton'

const toPerformanceForm = (rating: any): PowerPerformanceForms => {
  if (Object.values(PowerPerformanceForms).includes(rating as PowerPerformanceForms)) {
    return rating as PowerPerformanceForms
  }
  return PowerPerformanceForms.NOT_RATED
}

/**
 * Maps switchIneligibilityReason to exclusion reason message
 */
const getExclusionReason = (switchIneligibilityReason?: 'STCG' | 'ELSS' | 'IDCW'): string | undefined => {
  if (!switchIneligibilityReason) {
    return undefined
  }

  switch (switchIneligibilityReason) {
    case 'STCG':
      return "Switching now would cost you more in STCG taxes. We'll recommend a switch when its potential gains clearly outweigh the cost."
    case 'ELSS':
      return "Majority of this ELSS fund is still in lock-in period. Once it's eligible for withdrawal, we'll recommend the right switch."
    case 'IDCW':
      return "We're currently working on recommendations for IDCW funds, and will notify you as soon as they’re ready."
    default:
      return undefined
  }
}

interface ListOfUnderReviewFundsProps {
  summaryData: RegularToDirectSummaryResponse | undefined
  isLoading: boolean
  isError: boolean
}

export default function ListOfUnderReviewFunds({ summaryData, isLoading, isError }: ListOfUnderReviewFundsProps) {

  // Filter funds where exited is false AND switchRecommended is false
  const underReviewFunds =
    summaryData?.regularFunds?.filter((fund) => !fund.exited && !fund.directSwitchRecommended) || []

  if (isLoading) {
    return (
      <div className='px-5'>
        <div className='text-lg'>Funds currently under review</div>
        <div className='text-13 text-grey40 mb-4'>We'll let you know when it's time to switch them</div>
        <div>
          {[...Array(2)].map((_, index) => (
            <MutualFundListItemSkeleton key={index} isLast={index === 1} showChevron={true} />
          ))}
        </div>
      </div>
    )
  }

  if (isError || !summaryData || underReviewFunds.length === 0) {
    return null
  }

  return (
    <>
    <div className='px-5'>
      <div className='text-lg '>Funds currently under review</div>
      <div className='text-13 text-grey40 mb-4'>We'll let you know when it's time to switch them</div>
      </div>
      <>
        {underReviewFunds.map((fund, index) => {
          const isLast = index === underReviewFunds.length - 1
          const performanceForm = toPerformanceForm(fund.performanceRating)

          return (
            // <div key={fund.isin}>
              <MutualFundListItem
                isin={fund.isin}
                name={fund.name}
                fundNature={fund.fundNature}
                fundCategory={fund.fundCategory}
                purchaseMode={fund.purchaseMode}
                powerRank={fund.powerRank}
                performanceRating={performanceForm}
              missedGains={0}
              highExposure={false}
                mfLogoUrl={fund.mfLogoUrl}
                formType={performanceForm}
              sipAmount={0}
                isRegular={fund.purchaseMode === 'REGULAR'}
                riskProfile={null}
                borderRequired={true}
                isLast={isLast}
                // onClick={() => {
                //   openBottomSheet(
                //     <RegularToDirectBottomSheet
                //       fundName={fund.name}
                //       regularFundValue={fund.regularFundValue}
                //       onDismiss={closeBottomSheet}
                //       isRegular={fund.purchaseMode === 'REGULAR'}
                //       mfLogoUrl={fund.mfLogoUrl}
                //       name={fund.name}
                //       fundNature={fund.fundNature}
                //       fundCategory={fund.fundCategory}
                //       performanceRating={performanceForm}
                //     />
                //   )
                // }}
                additionalCommissionsPaid={fund.additionalCommissionsPaid}
              exclusionReason={getExclusionReason(fund.switchIneligibilityReason)}
              regularToDirectComparison={fund.regularToDirectComparison}
              directFundName={fund.directFundName}
              directFundISIN={fund.directFundIsin}
              />
            // </div>
          )
        })}
      </>
    </>
  )
}
